import React from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSafetyQuestion } from "../../services/safetyAPI";
import { useAuth } from "../../hooks/useAuth";
import SafetyCategorySelect from "./SafetyCategorySelect";

const CreateSafetyQuestionModal = ({ visible, onClose }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject?.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: createSafetyQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["safetyQuestions", projectId],
      });
      notification.success({ message: "Safety question created successfully" });
      form.resetFields();
      onClose();
    },
    onError: (error) => {
      notification.error({
        message: "Failed to create safety question",
        description:
          error.response?.data?.detail || error.message || "Unknown error",
      });
    },
  });

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = (values) => {
    mutation.mutate({
      project_id: projectId,
      text: values.text?.trim(),
      category: values.category?.trim() || "",
    });
  };

  return (
    <Modal
      title="Create Safety Question"
      open={visible}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      zIndex={1100}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="category" label="Category">
          <SafetyCategorySelect
            placeholder="Select category"
            className="w-full"
          />
        </Form.Item>
        <Form.Item
          name="text"
          label="Question"
          rules={[{ required: true, message: "Please enter a question" }]}
        >
          <Input.TextArea rows={3} placeholder="Question text" />
        </Form.Item>
        <Form.Item className="mb-0">
          <div className="flex justify-end gap-2">
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={mutation.isPending}>
              Create
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateSafetyQuestionModal;
